<template>
  <div
    class="add-visite"
  >
    <div class="archive-tip-m">
      {{ $t('message["1777"]') }}
    </div>
    <div
      ref="form"
      class="form"
    >
      <h2 class="title">
        {{ $t('message["1775"]') }}
      </h2>
      <cube-checkbox-group
        v-model="checkList"
        shape="square"
      >
        <cube-checkbox
          v-for="item in archiveTypesData"
          :key="item.id"
          :option="{value: item.id, disabled: item.disabled}"
          shape="square"
        >
          {{ item.name }}
        </cube-checkbox>
      </cube-checkbox-group>
    </div>
    <cube-form-group class="cube-picker-footer footer form-btn-box">
      <cube-button
        type="reset"
        class="cancel-btn cube-btn-light"
        @click="handleCancel"
      >
        {{ $t('message["896"]') }}
      </cube-button>
      <cube-button
        type="submit"
        class="confirm-btn cube-btn-primary"
        :loading="confirmLoading"
        @click="submitHandler"
      >
        {{ $t('message["915"]') }}
      </cube-button>
    </cube-form-group>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
const FROM_SOPURCE = 'notice'

export default {
  components: {
  },
  data () {
    return {
      confirmLoading: false,
      scroll: null,
      checkList: []
    }
  },
  computed: {
    ...mapState('inquery/detailData', [
      'archiveTypesData'
    ]),
    from () { // all, my, audit, checkrepeat
      return this.$route.query.from
    },
    type () {
      return this.$route.query.type
    },
    inquiryId () {
      return this.$route.params.inquiryId
    }
  },
  watch: {
    checkList (val) {
      if (val.includes(2)) {
        this.setDiasbled(3)
      } else if (val.includes(3)) {
        this.setDiasbled(2)
      } else {
        this.setDiasbled()
      }
    }
  },
  async created () {
    if (this.$route.tab === 'archive' || this.archiveTypesData.length <= 0) {
      await this.getArchiveTypes()
    }
  },
  methods: {
    ...mapActions('inquery/detailData', [
      'archiveInquiry',
      'getArchiveTypes'
    ]),
    hide () {
      this.$router.push({
        query: {
          ...this.$route.query,
          tab: 'baseDetail'
        }
      })
    },
    setDiasbled (key) {
      for (let i = 0; i < this.archiveTypesData.length; i++) {
        const item = this.archiveTypesData[i]
        if (item.id === key) {
          item.disabled = true
        } else {
          item.disabled = false
        }
      }
    },
    async submitHandler (e) {
      await this.confirmArchive()
    },

    handleCancel () {
      this.hide()
      this.checkList = []
    },
    async confirmArchive () {
      this.confirmLoading = true
      const chain = await this.archiveInquiry()
      chain
        .onSuccess((raw, res) => {
          if (!res.error) {
            let name = ''
            if (this.from === 'audit') {
              name = 'InqueryAudit'
            } else if (this.from === 'checkrepeat') {
              name = 'InqueryRepeat'
            } else {
              name = 'InqueryList'
            }
            if (this.from === FROM_SOPURCE) {
              this.$router.push({ name: 'recordNotice' })
            } else {
              this.$router.push({
                name,
                query: {
                  type: this.type,
                  from: this.from
                }
              })
            }
          }
        })
        .onNetSuccess(raw => {
          this.confirmLoading = false
        })
        .params({
          inquiryid: this.inquiryId,
          resettype: this.checkList
        })
        .fetch()
    }
  }
}
</script>

<style lang="scss" scoped>
.add-visite::v-deep {
  width: 100%;
  padding-bottom: 70px;
  background-color: #f5f5f5;
  .cube-checkbox {
    height: 56px;
    line-height: 56px;
  }
  .archive-tip-m {
    background: #FFF9EC;
    color:#F1B253;
    padding: 8px 16px;
    line-height: 24px;
    border: 1px solid #F6A953;
    border-left: none;
    border-right: none;
  }
}
h2.title {
  height: 40px;
  line-height: 40px;
  padding: 0 12px;
  font-size: 16px;
  color: #999;
  background-color: #f5f5f5;
}
.textarea-wrap {
  margin: 0;
  border-radius: 0;
}
.recycle-rule-tips {
  padding: 8px 12px;
  font-size: 12px;
  line-height: 24px;
  color: #FFC06A;
  background-color: #FFF9EC;
  border: solid 1px #F6A953;
  border-left: none;
  border-right: none;
}
.cube-btn {
  width: 48%;
}
</style>
